import React from "react";
import { StyledContainerChips } from "./ContainerChips.styled";
import { FilterOption } from "../../types/api/filters.type";
import { FilterProps } from "../../types/AppTypes";
import { Chip, ChipSizeEnum } from "../core/Chip/Chip";

type ContainerChipsProps = {
  options: FilterOption[];
  filters: FilterProps[];
  setSelectedChip: (x: number | string) => void;
  keyFilter: string;
};

export const ContainerChips = ({
  options,
  filters,
  setSelectedChip,
  keyFilter,
}: ContainerChipsProps) => {
  return (
    <StyledContainerChips>
      {options.map((option, index) => {
        const chipExist = filters.find((item) => item.key === keyFilter);
        const isSelected = chipExist?.value.includes(option.value);
        return (
          <Chip
            key={`${index}${option.value}`}
            option={option}
            selectedChip={isSelected}
            onSelectChip={setSelectedChip}
            size={ChipSizeEnum.BIG}
          />
        );
      })}
    </StyledContainerChips>
  );
};
